import React, { useMemo, useRef } from 'react';
import onClickAndHold from '@utils/onClickAndHold';
import { useSliderContext } from './context';
import IconArrow from '../icons/IconArrow';

interface Props {
  step?: number;
}

function Control({ step = 1 }: Props) {
  const { min, max, value, valToString, onChange } = useSliderContext();
  const valRef = useRef(value);

  const ratio = useMemo(() => {
    const decimal = String(step).split('.')[1];
    if (!decimal) return 1;
    return 10 ** decimal.length;
  }, [step]);

  const handleLeftClick = () => {
    valRef.current = value;
    const fn = () => {
      const newVal =
        Math.round(Math.max(min, valRef.current - step) * ratio) / ratio;
      valRef.current = newVal;
      onChange(newVal);
    };
    onClickAndHold(fn);
  };

  const handleRightClick = () => {
    valRef.current = value;
    const fn = () => {
      const newVal =
        Math.round(Math.min(max, valRef.current + step) * ratio) / ratio;
      valRef.current = newVal;
      onChange(newVal);
    };
    onClickAndHold(fn);
  };

  return (
    <div className="mt-10 flex items-center text-sm text-black-gray">
      <IconArrow
        className="mr-4 rotate-90 transform"
        onMouseDown={handleLeftClick}
      />
      <div>{valToString(min)}</div>
      <div className="ml-auto">{valToString(max)}</div>
      <IconArrow
        className="ml-4 -rotate-90 transform"
        onMouseDown={handleRightClick}
      />
    </div>
  );
}

export default Control;
